import { useCallback, useState } from "react";
import { useAuthContext } from "@/components/AuthProvider";
import { useSinirCredentialStatus } from "@/hooks/useSinirCredentialStatus";
import { isSinirAnnouncementActive } from "@/config/sinirLoginAnnouncement";
import { openCloudHumansChat } from "@/utils/cloudHumans";

/**
 * Decide se o pop-up de aviso de alteração de login no Sinir (GR-564) deve
 * ser exibido, e expõe as ações de fechar/contatar suporte.
 *
 * Regras:
 * - Só aparece para geradores externos (is_internal === false).
 * - Só aparece se houver ao menos uma credencial ativa do Sinir.
 * - Só aparece enquanto o anúncio estiver ativo (até 31/07/2026).
 * - Some silenciosamente se a consulta de credencial falhar.
 * - Uma vez fechado (X, clique fora ou contato), some para o resto da
 *   sessão atual do app (estado em memória, não persistido).
 */
export function useSinirLoginAnnouncement() {
  const { profile } = useAuthContext();
  const { hasActiveCredential, isError } = useSinirCredentialStatus();
  const [dismissed, setDismissed] = useState(false);
  const [contactError, setContactError] = useState(false);

  const shouldShow =
    !!profile &&
    profile.is_internal === false &&
    hasActiveCredential &&
    !isError &&
    isSinirAnnouncementActive() &&
    !dismissed;

  const onClose = useCallback(() => {
    setDismissed(true);
  }, []);

  const onContactClick = useCallback(() => {
    if (typeof window.$cloudchat !== "undefined") {
      openCloudHumansChat();
      setContactError(false);
      setDismissed(true);
    } else {
      setContactError(true);
    }
  }, []);

  return { shouldShow, onClose, onContactClick, contactError };
}
